import $ from "jquery";

export function initBlockPipeForAllElementsNamedEmail() {
    $('[name="email"]').keyup(function () {
        this.value = this.value.replace(/[|]/, "");
    });
}
